import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { StorageKey } from '@/client/types'
import { getDsData, updateMutateDesignService, updateMutateDesignServiceBrief } from '@/infra/services/designService'

export const useMutateDesignService = () => {
  const queryClient = useQueryClient()
  const { mutate, isSuccess, data, isLoading } = useMutation({
    mutationKey: [StorageKey.DESIGN_SERVICES],
    mutationFn: () => updateMutateDesignService(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [StorageKey.DESIGN_SERVICES] })
    }
  })

  return {
    mutate,
    isLoading: !!isLoading,
    isSuccess: !!isSuccess,
    response: data
  }
}

/**
 *
 * Get Design Service data.
 *
 * @param locale - Language
 * @returns
 */
export const useGetDs = (locale: string = 'es') =>
  useQuery([StorageKey.DESIGN_SERVICES_DATA, locale], {
    queryFn: () => getDsData(locale),
    onSuccess: () => {},
    enabled: !!locale,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  })

export const useMutateDesignServiceBrief = (locale: string = 'es') => {
  const queryClient = useQueryClient()
  const { mutate, isSuccess, data, isLoading } = useMutation({
    mutationKey: [StorageKey.DESIGN_SERVICES_MUTATION],
    mutationFn: (payload: any) =>
      updateMutateDesignServiceBrief(locale, payload.content, payload.cartId, payload.customerId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [StorageKey.DESIGN_SERVICES] })
    }
  })

  return {
    mutate,
    isLoading: !!isLoading,
    isSuccess: !!isSuccess,
    response: data
  }
}
